import React from 'react';
import {useMemo} from 'react';
import {VisualizationSpec} from 'react-vega';
import CustomPanelRenderer from '../Vega3/CustomPanelRenderer';
import * as Panel2 from './panel';
import * as CGReact from './cg/cgreact';

// Note: This will make one histogram for each key present in the first
// object in the array. (we're pivoting it). We may want force that
// its passed in pivoted by the type.
// TODO: Fix when figuring out how to make generic plot panels that
// can choose their own input functions.

const inputType = {
  type: 'array' as const,
  objectType: {
    type: 'dict' as const,
    objectType: {
      type: 'union' as const,
      members: [null, 'number' as const],
    },
  },
};

type PanelMultiHistogramProps = Panel2.PanelProps<typeof inputType>;

/* eslint-disable no-template-curly-in-string */

const HISTO_SPEC: VisualizationSpec = {
  $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
  description: 'A simple histogram',
  data: {
    name: 'wandb',
  },
  title: '${string:title}',
  mark: {type: 'bar', tooltip: {content: 'data'}},
  encoding: {
    x: {
      bin: true,
      type: 'quantitative',
      field: 'value',
      axis: {
        title: null,
      },
    },
    color: {
      field: 'name',
      title: null,
    },
    y: {
      aggregate: 'count',
      stack: null,
      axis: {
        title: null,
      },
    },
    opacity: {value: 0.7},
    order: {
      field: 'name',
    },
  },
};

const PanelMultiHistogram: React.FC<PanelMultiHistogramProps> = props => {
  const nodeValueQuery = CGReact.useNodeValue(props.input.path);
  const data = useMemo(() => {
    const nodeValue = nodeValueQuery.result;
    if (nodeValueQuery.loading || nodeValue.length === 0) {
      return [];
    }
    const keys = Object.keys(nodeValue[0]);
    const result: Array<{name: string; value: number}> = [];
    for (const row of nodeValue) {
      for (const key of keys) {
        result.push({name: key, value: (row as any)[key]});
      }
    }
    return result;
  }, [nodeValueQuery.loading, nodeValueQuery.result]);
  return (
    <div style={{width: 250, height: 160}}>
      <CustomPanelRenderer
        spec={HISTO_SPEC}
        loading={props.loading}
        slow={false}
        data={data}
        userSettings={{fieldSettings: {}, stringSettings: {title: ''}}}
      />
    </div>
  );
};

export const Spec: Panel2.PanelSpec = {
  id: 'multi-histogram',
  displayName: 'MultiHistogram',
  Component: PanelMultiHistogram,
  inputType,
};
